"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactSizeme = require("react-sizeme"),
    _uiKit = require("@devsta/ui-kit"),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _lodash2 = _interopRequireDefault(require("lodash.get")),
    _requiresPermission = require("../../../../requiresPermission"),
    _DeleteConfirmationModal = _interopRequireDefault(require("../../../../DeleteConfirmationModal")),
    _Notifications = require("../../../../Notifications"),
    _DropZone = _interopRequireDefault(require("../../DropZone")),
    _AssetsListCard = _interopRequireDefault(require("./AssetsListCard")),
    _AssetsListItem = _interopRequireDefault(require("./AssetsListItem")),
    _constants = require("../../../constants"),
    _confirmActions = _interopRequireDefault(require("../../ConfirmationModal/constants/confirmActions"));

require("../styles/_assets-list.scss");

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var IN_PROGRESS = "IN_PROGRESS",
    SEARCH_FILTER = {
  filterType: "SEARCH",
  defaultValue: ""
},
    LIST_FILTERS = {
  ARCHIVED_FILTER: [{
    label: "Active",
    value: "ACTIVE"
  }, {
    label: "Archived",
    value: "ARCHIVED"
  }]
},
    AssetsList = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.showManageAssetModal = (0, _lodash["default"])(function (a) {
      return function () {
        var b = d.props.showModal;
        b(a);
      };
    }), d.showConfirmationModalHandler = (0, _lodash["default"])(function (a) {
      var b = a.asset,
          c = a.confirmModalAction;
      return function () {
        var a = d.props.showConfirmationModal;
        return a({
          assetId: b.assetId,
          confirmModalAction: c
        });
      };
    }), d.getOptions = (0, _lodash["default"])(function (a) {
      var b = d.props,
          c = b.archivedFilter,
          e = b.orgPermissions,
          f = b.isListEditable;
      if (!f) return [{
        label: "View Details",
        action: d.showManageAssetModal(a)
      }];
      var g = (0, _lodash2["default"])(a, "assetFiles.ORIGINAL.status", IN_PROGRESS) !== IN_PROGRESS && (0, _requiresPermission.hasPermission)("DELETE_ASSET", e),
          h = (0, _requiresPermission.hasPermission)("ARCHIVE", a.permissions);
      return [{
        label: "Manage Details",
        action: d.showManageAssetModal(a)
      }].concat((0, _toConsumableArray2["default"])(h && "ARCHIVED" === c ? [{
        action: d.showConfirmationModalHandler({
          asset: a,
          confirmModalAction: _confirmActions["default"].UNARCHIVE
        }),
        label: "Unarchive"
      }] : []), (0, _toConsumableArray2["default"])(h && "ARCHIVED" !== c ? [{
        action: d.showConfirmationModalHandler({
          asset: a,
          confirmModalAction: _confirmActions["default"].ARCHIVE
        }),
        label: "Archive"
      }] : []), (0, _toConsumableArray2["default"])(g ? [{
        action: d.handleDeleteAsset({
          asset: a
        }),
        label: "Delete",
        isRed: !0
      }] : []));
    }), d.handleDeleteAsset = function (a) {
      var b = a.asset;
      return function () {
        d.setState({
          assetId: b.assetId,
          assetTitle: b.title || "Asset",
          showDeleteConfirmation: !0,
          hasAssetRelation: !1
        });
      };
    }, d.hideModal = function () {
      d.setState({
        showDeleteConfirmation: !1
      });
    }, d.onComplete = function () {
      var a = d.props.onDeleteComplete,
          b = d.state,
          c = b.assetId,
          e = b.assetTitle;
      d.setState({
        showDeleteConfirmation: !1
      }, function () {
        (0, _Notifications.notify)({
          content: "".concat(e, " successfully deleted"),
          type: "success"
        }), a(c);
      });
    }, d.rowRenderer = function (a) {
      var b = a.key,
          c = a.index,
          e = a.style,
          f = d.props.assets,
          g = void 0 === f ? [] : f;
      return _react["default"].createElement("div", {
        key: b,
        style: e
      }, d.renderListItem(g[c]));
    }, d.renderCardItem = function (a) {
      return _react["default"].createElement(_AssetsListCard["default"], {
        item: a,
        handleClick: d.showManageAssetModal(a),
        options: d.getOptions(a)
      });
    }, d.renderListItem = function (a) {
      return _react["default"].createElement(_AssetsListItem["default"], {
        item: a,
        handleClick: d.showManageAssetModal(a),
        options: d.getOptions(a)
      });
    }, d.state = {
      showDeleteConfirmation: !1,
      hasAssetRelation: !1,
      assetTitle: ""
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this,
          b = this.props,
          c = b.setFilePickerRef,
          d = b.history,
          e = b.loading,
          f = b.assets,
          g = b.dropZoneDisplayed,
          h = b.handleFilterChange,
          i = b.closeDropZone,
          j = b.deleteAsset,
          k = b.loadMoreResults,
          l = b.totalResults,
          m = b.getListRef,
          n = b.listProps,
          o = void 0 === n ? {} : n,
          p = b.isListEditable,
          q = b.showActiveFilter,
          r = this.state,
          s = r.showDeleteConfirmation,
          t = r.assetId,
          u = r.hasAssetRelation,
          v = p && !e && g,
          w = o.renderCardItem,
          x = o.renderListItem;
      return _react["default"].createElement(_reactSizeme.SizeMe, null, function (b) {
        var g = b.size;
        return _react["default"].createElement("div", {
          className: (0, _classnames["default"])("library-asset-list", "column", {
            "library-asset-list--hide-assets": v,
            "library-asset-list--small": g.width < _constants.mediaSizes.small
          })
        }, _react["default"].createElement(_DropZone["default"], {
          setFilePickerRef: c,
          closeDropZone: i,
          isVisible: v,
          handleDragOut: i
        }), !v && _react["default"].createElement(_uiKit.List, (0, _extends2["default"])({
          autoHeight: !0,
          height: 2e3,
          loading: e,
          history: d,
          renderCardItem: void 0 === w ? a.renderCardItem : w,
          renderListItem: void 0 === x ? a.renderListItem : x,
          emptyDataText: " ",
          data: f,
          filters: void 0 === q || q ? LIST_FILTERS : {},
          onFiltersChange: h,
          options: [],
          searchFilter: SEARCH_FILTER,
          listKey: "assetId",
          loadMoreResults: k,
          totalResults: l,
          getInfiniteScrollParent: m
        }, o)), t && s && _react["default"].createElement(_DeleteConfirmationModal["default"], {
          onDelete: j,
          objectId: t,
          hideModal: a.hideModal,
          onComplete: a.onComplete,
          title: "Delete Asset",
          subTitle: "Are you sure you want to delete this asset?",
          warnings: u ? ["All asset references will be removed"] : []
        }));
      });
    }
  }]), b;
}(_react.Component);

exports["default"] = AssetsList;